import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import { FiEdit } from "react-icons/fi";
import { IoIosAddCircle } from "react-icons/io";
import Model from "../../../component/Model/Model";
import {
  useCreateMutation,
  // useDeleteRecordMutation,
  useGetVehicleMakeQuery,
  useGetVehicleModelQuery,
  useUpdateMutation,
} from "../../../store/api/configurationSlice";
import { IoCloseSharp } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import SkeletonLoading from "../../../component/SkeletonLoading";
import CreateModal from "../../../component/Model/CreateModel";
import AdminPagination from "../../../component/pagination/AdminPagination";
import { useTranslation } from "react-i18next";
import i18n from "../../../store/api/i18n";

const initialState = {
  name: "",
  make_id: "",
};

const ModalPage = () => {
  const { t } = useTranslation();
  // const [show, setShow] = useState(false);
  // const [id, setId] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [editData, setEditData] = useState(null);
  const [makes, setMakes] = useState([]);
  const [models, setModels] = useState([]);
  const [show2, setShow2] = useState(false);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    search: "",
  });

  // Get Vehicle Model
  const { data, isLoading, isSuccess, isFetching, refetch } =
    useGetVehicleModelQuery({
      page: pagination.page,
      limit: pagination.limit,
      search: pagination.search,
    });

  // Get Vehicle Make
  const {
    data: makesData,
    isSuccess: isMakeSuccess,
    refetch: refetchMake,
  } = useGetVehicleMakeQuery({});

  // Create Name
  const [create, { isLoading: isAddLoading }] = useCreateMutation();

  // Update Name
  const [update, { isLoading: isUpdateLoading }] = useUpdateMutation();

  // Delete Vehicle Model
  // const [deleteVehicleModel, { isLoading: isDeletingModal }] =
  //   useDeleteRecordMutation();

  useEffect(() => {
    if (isSuccess && data?.data) {
      setModels(data?.data?.models);
      setPagination((prev) => ({
        ...prev,
        total: data.data.pagination.total,
        page: data.data.pagination.page,
        limit: data.data.pagination.limit,
        totalPages: data.data.pagination.pages,
      }));
    }
  }, [data, isSuccess]);

  useEffect(() => {
    if (isMakeSuccess && makesData?.data) {
      setMakes(makesData?.data?.makes);
    }
  }, [makesData, isMakeSuccess]);

  // show model
  // const handleShow = (id) => {
  //   setShow(true);
  //   setId(id);
  // };

  // show edit model
  const handleEdit = ({ name, id, make_id }) => {
    setEditData(null);

    setEditData({ name, id, make_id });
    setShowModel(true);
  };

  // Delete Vehicle Model
  // const handleDelete = async () => {
  //   try {
  //     const response = await deleteVehicleModel({
  //       id,
  //       endPoint: "vehicle-model",
  //     }).unwrap();
  //     if (response.statusCode === 200) {
  //       toast.success(response.message);
  //       setShow(false);
  //       setId("");
  //     }
  //   } catch (err) {
  //     const mesg = err.data?.message || "Something went wrong";
  //     toast.error(mesg);
  //   }
  // };

  const handleClose = () => {
    setShow2(false);
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setPagination((prev) => ({
      ...prev,
      limit,
      page: 1,
    }));
  };

  const handleSearch = () => {
    setPagination((prev) => ({
      ...prev,
      page: 1,
      search: search.trim(),
    }));
  };

  useEffect(() => {
    if (!search.trim()) {
      setPagination((prev) => ({
        ...prev,
        search: "",
      }));
    }
  }, [search]);

  // Language Change Handler
  useEffect(() => {
    const h = () => {
      refetch?.();
      refetchMake?.();
    };
    i18n.on("languageChanged", h);
    return () => i18n.off("languageChanged", h);
  }, [refetch, refetchMake]);

  const handleClose2 = () => {
    setShowModel(false);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap w-100 mb-2">
        <div className="total">
          {t("total")}: {pagination.total}
        </div>

        <div className="d-flex flex-wrap gap-2">
          <div className="d-flex flex-grow-1">
            <input
              type="text"
              className="form-control custom-field-one"
              placeholder={`${t("search")} ${t("by")} ${t("model")} ${t("name")}`}
              value={search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="d-flex gap-2 flex-grow-1">
            <button
              className="btn btn-primary flex-grow-1"
              onClick={handleSearch}
            >
              {t("search")}
            </button>

            <Button
              className="d-flex align-items-center gap-1 flex-grow-1 justify-content-center"
              onClick={() => setShowModel(true)}
            >
              <IoIosAddCircle size={15} fill="white" />
              {t("add")}
            </Button>
          </div>
        </div>
      </div>

      <Model
        show={showModel}
        onHide={handleClose2}
        initialState={initialState}
        editData={editData}
        title={
          editData
            ? `${t("update")} ${t("vehicle")} ${t("model")}`
            : `${t("add")} ${t("vehicle")} ${t("model")}`
        }
        submit={editData ? update : create}
        EndPoint="vehicle-model"
        loading={isAddLoading || isUpdateLoading}
        makes={makes}
        onSuccess={() => setShow2(true)}
      />

      <div className="table m-0">
        <table>
          <thead>
            <tr>
              <th>
                {t("SR")}.{t("no")}.
              </th>
              <th>
                {t("vehicle")} {t("make")}
              </th>
              <th>
                {t("vehicle")} {t("model")}
              </th>
              <th width="70px">{t("action")}</th>
            </tr>
          </thead>
          <tbody>
            {isLoading || isFetching ? (
              <SkeletonLoading length={4} />
            ) : models.length > 0 ? (
              models.map((item, i) => (
                <tr key={i}>
                  <td>{(pagination.page - 1) * pagination.limit + i + 1}</td>
                  <td>{item?.make_name}</td>
                  <td>{item?.name}</td>
                  <td>
                    <div className="actionBtn d-flex">
                      <Button
                        title={t("edit")}
                        className="rounded-circle me-2"
                        onClick={() => handleEdit(item)}
                      >
                        <FiEdit />
                      </Button>
                      {/* <Button
                              title="Delete"
                              className="rounded-circle"
                              onClick={() => handleShow(item.id)}
                            >
                              <RiDeleteBin6Fill />
                            </Button> */}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="12">
                  <div>
                    <span>
                      {t("no")} {t("vehicle")} {t("model")} {t("found")}
                    </span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <AdminPagination
        totalPages={pagination.totalPages}
        currentPage={pagination.page}
        limit={pagination.limit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
      />

      {/* Delete Confirmation Modal */}
      {/* <Modal show={show}>
          <Button className="closePopup" onClick={() => setShow(false)}>
            <IoCloseSharp />
          </Button>
          <div className="popupBox p-3 p-md-5">
            <div>
              <div className="text-center mb-3 errorIcon">
                <BiSolidError />
              </div>
              <div className="text-center mb-4 deleteHd">
                Are you sure you want to delete?
              </div>
              <div className="text-center">
                <Button
                  className="smallBtn cancel me-3"
                  onClick={() => setShow(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="smallBtn auto"
                  onClick={handleDelete}
                  disabled={isDeletingModal}
                >
                  {isDeletingModal ? (
                    <div className="spinner-border" role="status">
                      <span className="sr-only p-0"></span>
                    </div>
                  ) : (
                    "Delete"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Modal> */}

      <Modal show={show2}>
        <Button className="closePopup" onClick={handleClose}>
          <IoCloseSharp />
        </Button>
        <CreateModal
          title={`${t("vehicle")} ${t("model")} ${
            editData ? t("updated") : t("added")
          } ${t("successfully")}!`}
          text={`${
            editData
              ? `${t("vehicle")} ${t("model")} ${t("has")} ${t("been")} ${t(
                  "updated",
                )}.`
              : `${t("vehicle")} ${t("model")} ${t("has")} ${t("been")} ${t(
                  "added",
                )}.`
          }`}
          onClose={handleClose}
        />
      </Modal>
    </>
  );
};

export default ModalPage;
